// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_UpdateCompromissoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /compromissos/updateCompromisso
 *
 * Validates input for updating an existing compromisso with full field validation.
 */
import { registerContract } from './validate'

export interface Compromissos_UpdateCompromissoInput {
compromisso_id: number
compromisso_franquia_id: number
compromisso_operador_user_id: string
compromisso_status: string
compromisso_forma_pagamento: string
compromisso_data_hora_inicio: string
compromisso_data_hora_fim: string
compromisso_checkin?: string
compromisso_checkout?: string
}

registerContract('Compromissos_UpdateCompromissoInput', {
  compromisso_id:               { type: 'number',  required: true },
  compromisso_franquia_id:      { type: 'number',  required: true },
  compromisso_operador_user_id: { type: 'string',  required: true },
  compromisso_status:           { type: 'string',  required: true },
  compromisso_forma_pagamento:  { type: 'string',  required: true },
  compromisso_data_hora_inicio: { type: 'string',  required: true },
  compromisso_data_hora_fim:    { type: 'string',  required: true },
  compromisso_checkin:          { type: 'string',  required: false },
  compromisso_checkout:         { type: 'string',  required: false },
})
